<script lang="ts">
  const MAX_STEPS = 2;

  interface Props {
    totalSteps?: number;
    currentStep?: number;
  }

  let { totalSteps = 2, currentStep = 1 }: Props = $props();

  let isUnsupported = $derived(totalSteps > MAX_STEPS);
  let barClassName = $derived(`progress-bar-width-${Math.round((currentStep / totalSteps) * 100)}`);
</script>

{#if isUnsupported}
  <div class="unsupported">Progress bar supports a maximum of {MAX_STEPS} steps.</div>
{:else}
  <div class="progress-track">
    <div class="progress-bar {barClassName}"></div>
  </div>
{/if}

<style>
  .progress-track {
    height: 4px;
    background: var(--grey-bg);
    width: 100%;
  }
  .progress-bar {
    height: 4px;
    background: var(--green);
    transition: width 0.3s ease;
  }
  .progress-bar-width-50 {
    width: 50%;
  }
  .progress-bar-width-100 {
    width: 100%;
  }
  .unsupported {
    font-size: 12px;
    color: var(--grey-medium);
    padding: 4px 0;
    text-align: center;
  }
</style>
